import { ContentPage } from "../components/layout/ContentPage";

import { useTranslation } from "../i18n";
import { createTranslatedMeta } from "../utils/routeMeta";

export const meta = createTranslatedMeta({
	titleKey: "meta.aboutTitle",
	descriptionKey: "meta.aboutDescription",
	path: "/about",
});

export default function About() {
	const { t, messages } = useTranslation();

	const features = messages.about.features;

	return (
		<ContentPage title={t("about.title")} subtitle={t("about.subtitle")}>
			<section className="space-y-4">
				<p>{t("about.intro")}</p>
			</section>

			<section>
				<h2>{t("about.featuresTitle")}</h2>
				<ul>
					{features.map(feature => (
						<li key={feature.label}>
							<strong>{feature.label}</strong> {feature.desc}
						</li>
					))}
				</ul>
			</section>

			<section>
				<h2>{t("about.superSplatTitle")}</h2>
				<ol>
					<li>
						<a href="https://superspl.at/editor" target="_blank" rel="noopener noreferrer">
							{t("about.superSplatEditor")}
						</a>{" "}
						{messages.about.superSplatSteps[0]}
					</li>
					<li>
						<strong>Export</strong> → <strong>Viewer App</strong> {messages.about.superSplatSteps[1]}
					</li>
					<li>{messages.about.superSplatSteps[2]}</li>
					<li>{messages.about.superSplatSteps[3]}</li>
				</ol>
			</section>

			<section className="not-prose flex flex-col gap-4 border-t border-border pt-6 sm:flex-row sm:items-center">
				<img
					src="https://pbs.twimg.com/profile_images/1223184308799598592/Fdtkt9ih_400x400.jpg"
					alt="Ryuto Haga"
					className="h-20 w-20 shrink-0 rounded-full object-cover"
				/>
				<div>
					<h2 className="text-base font-semibold text-foreground">{t("about.creatorTitle")}</h2>
					<p className="mt-2 text-sm text-muted-foreground">{t("about.creatorBio")}</p>
					<a
						href="https://x.com/yushimatenjin2"
						target="_blank"
						rel="noopener noreferrer"
						className="mt-2 inline-block text-sm font-medium text-primary underline underline-offset-4"
					>
						@yushimatenjin2 on X
					</a>
				</div>
			</section>
		</ContentPage>
	);
}
